import { FindDropsListType, sortingOrder, WellInfoAllSortDataType } from './Contants';

export const handleSort = (
  sortNumber: number,
  wellCardList: FindDropsListType,
  wellInfoData: WellInfoAllSortDataType,
) => {
  const selectedValue = wellInfoData[sortNumber].selectedValue;
  let sortedData = [...wellCardList];

  if (selectedValue === 'Select') {
    return sortedData;
  }
  sortedData = PerformSort(sortNumber, sortedData, wellInfoData);
  return sortedData;
};

export const PerformSort = (
  sortNumber: number,
  wellCardList,
  wellInfoData: WellInfoAllSortDataType,
) => {
  let sortedData = [];
  sortedData = wellCardList.sort(
    (a, b) =>
      (sortNumber === 0
        ? wellInfoData[0].sortOrder === sortingOrder.ASCENDING
          ? b[wellInfoData[0].selectedValue] - a[wellInfoData[0].selectedValue]
          : a[wellInfoData[0].selectedValue] - b[wellInfoData[0].selectedValue]
        : wellInfoData[0].sortOrder === sortingOrder.ASCENDING
        ? a[wellInfoData[0].selectedValue] - b[wellInfoData[0].selectedValue]
        : b[wellInfoData[0].selectedValue] - a[wellInfoData[0].selectedValue]) ||
      (sortNumber === 1
        ? wellInfoData[1].sortOrder === sortingOrder.ASCENDING
          ? b[wellInfoData[1].selectedValue] - a[wellInfoData[1].selectedValue]
          : a[wellInfoData[1].selectedValue] - b[wellInfoData[1].selectedValue]
        : wellInfoData[1].sortOrder === sortingOrder.ASCENDING
        ? a[wellInfoData[1].selectedValue] - b[wellInfoData[1].selectedValue]
        : b[wellInfoData[1].selectedValue] - a[wellInfoData[1].selectedValue]) ||
      (sortNumber === 2
        ? wellInfoData[2].sortOrder === sortingOrder.ASCENDING
          ? b[wellInfoData[2].selectedValue] - a[wellInfoData[2].selectedValue]
          : a[wellInfoData[2].selectedValue] - b[wellInfoData[2].selectedValue]
        : wellInfoData[2].sortOrder === sortingOrder.ASCENDING
        ? a[wellInfoData[2].selectedValue] - b[wellInfoData[2].selectedValue]
        : b[wellInfoData[2].selectedValue] - a[wellInfoData[2].selectedValue]),
  );
  return sortedData;
};

export const changeScoreSelectedItems = (
  score,
  allWellsScoresList,
  selectedScoreGroups,
  setSelectedScoreGroups,
  scoresSelection,
  lastActionPerformed,
) => {
  let newSelectedScoresList = [...selectedScoreGroups];
  if (
    newSelectedScoresList.some(
      (selectedScore) =>
        selectedScore.scoreGroupName === score.scoreGroupName &&
        selectedScore.scoreName === score.scoreName,
    )
  ) {
    newSelectedScoresList = newSelectedScoresList.filter(
      (selectedScore) => selectedScore.scoreName !== score.scoreName,
    );
  } else {
    const newScores = [...allWellsScoresList].filter(
      (newScore) =>
        newScore.wellDropScoreId === score.wellDropScoreId &&
        newScore.wellDropScoreGroupId === score.wellDropScoreGroupId,
    );
    newScores.length
      ? newScores.every((element) => newSelectedScoresList.push(element))
      : newSelectedScoresList.push(score);
  }
  scoresSelection(lastActionPerformed.scores, newSelectedScoresList, allWellsScoresList);
  setSelectedScoreGroups(newSelectedScoresList);
};
